import { useEffect, useState } from "react";
import { BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import CameraViewPage, { getDefaultPageUI as getCameraViewPageDefaultPageUI } from "components/pages/CameraViewPage";
import CheckImageBackManualPage from "components/pages/CheckImageBackManualPage";
import { PageContainer } from "components/shared";

export default function CaptureMabiDepositsCheckBack(props) {
    const [mabi23Branding, setMabi23Branding ] = useState({});

    const mabi23BrandingIsSet = Object.keys(mabi23Branding).length > 0;
    let mobileDepositsVersion = undefined;

    if(mabi23Branding.options) {
        mobileDepositsVersion = mabi23Branding.options.mobile_deposits_version_mabi23;
    }

    mobileDepositsVersion = mobileDepositsVersion === undefined || mobileDepositsVersion === "undefined" ? "Front & Back Images" : mobileDepositsVersion;
    mobileDepositsVersion = mobileDepositsVersion.toLowerCase();
    const hasAManualDepositVersion = mobileDepositsVersion === "manual front & back images" || mobileDepositsVersion === "manual check images";

    // useEffect will listen to the window event that triggers 
    // when mabi23 branding has been set in abi22.
    useEffect(() => {
        const handle = evt => {
            if(!mabi23BrandingIsSet) {
                setMabi23Branding(evt.detail);
            }
        }

        window.addEventListener("didSetMabi23Branding", handle);

        return () => {
            window.removeEventListener("didSetMabi23Branding", handle)
        };
    }, [mabi23Branding]);

    const ui = BCMSStateManagerCRUD.init(getCameraViewPageDefaultPageUI())
    .update([ "selectedCheckView" ], "back")
    .submit();

    return (
        <>
            { !mabi23BrandingIsSet && <PageContainer className="hide"/> }
            { mabi23BrandingIsSet && hasAManualDepositVersion && <CheckImageBackManualPage className="capture-styles" /> }
            { mabi23BrandingIsSet && !hasAManualDepositVersion && <CameraViewPage ui={ ui } className="capture-styles" />}
        </>
    );
}